import { defineMessages } from 'react-intl';

export const patientResultRowMessages = defineMessages({
  unnamedPatient: {
    defaultMessage: 'Unnamed patient',
    id: 'mD6rX6xUBT',
    description:
      'Fallback label in the patient search row when a patient has neither a name nor a demographic summary',
  },
  lastVisit: {
    defaultMessage: 'Last visit: {gist}',
    id: '2OVLGyjJVw',
    description:
      'Secondary line in patient search showing an AI summary of the patient’s most recent session',
  },
  sawRelative: {
    defaultMessage: 'Saw {relative}',
    id: '037qpcQ9Ef',
    description:
      'Secondary line in patient search showing when the patient was last seen, relative to today',
  },
});
